module.exports = __webpack_public_path__ + "img/ceramics-building-2600-2x.c6914e95.jpg";